// Topic records are loaded from /bff/topics. These compatibility globals start
// empty so no representative counts or authored concept claims can leak into UI.
const CONCEPTS = [];
const conceptById = () => null;
Object.assign(window, { CONCEPTS, conceptById });
